<template>
  <div>
    <!-- <pre>aaaa:::{{ this.$store.state.main.bookingDetails.billingInfo }}</pre> -->
    <h4 class="font-bold">Billing address</h4>

    <div class="vx-row my-8">
      <!-- First name  -->
      <div class="vx-col w-full">
        <vs-input
          v-validate="'required|alpha_spaces'"
          class="w-full md:w-8/12"
          label="First name"
          name="First name"
          v-model="billingInfo.firstName"
          @blur="validate"
        />
        <span class="text-danger text-sm" v-show="errors.has('First name')">{{
          errors.first("First name")
        }}</span>
      </div>
      <!-- Last name  -->
      <div class="vx-col w-full mt-5">
        <vs-input
          v-validate="'required|alpha_spaces'"
          class="w-full md:w-8/12"
          label="Last name"
          name="Last name"
          v-model="billingInfo.lastName"
          @blur="validate"
        />
        <span class="text-danger text-sm" v-show="errors.has('Last name')">{{
          errors.first("Last name")
        }}</span>
      </div>
      <!-- Email  -->
      <div class="vx-col w-full mt-5">
        <vs-input
          v-validate="'required|email'"
          class="w-full md:w-8/12"
          label="Email"
          name="Email"
          v-model="billingInfo.email"
          @blur="validate"
        />
        <span class="text-danger text-sm" v-show="errors.has('Email')">{{
          errors.first("Email")
        }}</span>
      </div>
      <!-- Contact number  -->
      <div class="vx-col w-full mt-5">
        <vs-input
          v-validate="'required|numeric'"
          class="w-full md:w-8/12"
          label="Contact number"
          name="Contact number"
          v-model="billingInfo.phone"
          @blur="validate"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Contact number')"
          >{{ errors.first("Contact number") }}</span
        >
      </div>
      <!-- Country of residence  -->
      <!-- <div class="vx-col w-full mt-5">
        <vs-input
          v-validate="'required|alpha'"
          class=" w-8/12"
          label="Country of residence"
          name="Country of residence"
          v-model="country"
          @blur="validate"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Country of residence')"
          >{{ errors.first("Country of residence") }}</span
        >
      </div> -->
      <!-- Country  -->
      <div class="vx-col w-full mt-5">
        <v-select
          v-validate="'required'"
          class="w-full md:w-8/12"
          label="Country of residence"
          name="Country of residence"
          v-model="billingInfo.country"
          @select="validate"
          :options="countries"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Country of residence')"
          >{{ errors.first("Country of residence") }}</span
        >
      </div>

      <!-- Address  -->
      <div class="vx-col w-full mt-5">
        <vs-input
          v-validate="'required'"
          class="w-full md:w-8/12"
          label="Address"
          name="Address"
          v-model="billingInfo.address"
          @blur="validate"
        />
        <span class="text-danger text-sm" v-show="errors.has('Address')">{{
          errors.first("Address")
        }}</span>
      </div>
      <!-- City  -->
      <div class="vx-col w-full mt-5">
        <vs-input
          v-validate="'required'"
          class="w-full md:w-8/12"
          label="City"
          name="City"
          v-model="billingInfo.city"
          @blur="validate"
        />
        <span class="text-danger text-sm" v-show="errors.has('City')">{{
          errors.first("City")
        }}</span>
      </div>
      <!-- post Code  -->
      <div class="vx-col w-full mt-5">
        <vs-input
          v-validate="'required|numeric'"
          class="w-full md:w-8/12"
          label="Postcode"
          name="Postcode"
          v-model="billingInfo.postcode"
          @blur="validate"
        />
        <span class="text-danger text-sm" v-show="errors.has('Postcode')">{{
          errors.first("Postcode")
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import countries from "@/components/hawk/js/countries.js";
export default {
  data() {
    return {
      billingInfo: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "60",
        country: "Malaysia",
        address: "",
        city: "",
        postcode: "",
      },
      countries: countries,
    };
  },
  methods: {
    validate() {
      this.$validator.validateAll();
    },
  },
  watch: {
    billingInfo: {
      deep: true,
      handler(newVal) {
        this.$store.state.main.bookingDetails.billingInfo = newVal;
      },
    },
  },
  components: {
    vSelect,
  },
};
</script>
